import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import {
  EditableItem,
  EditListModalBase,
  EditListSchema,
} from '../../../../shared/bases/edit-list-modal.base';
import { GLOBAL_CONFIRMATION_DELETE } from '../../../../shared/constants/global-key.constans';

interface PotentialConsequence extends EditableItem {}

@Component({
  selector: 'app-edit-potential-consequences-modal',
  templateUrl: './edit-potential-consequences-modal.component.html',
  styleUrl: './edit-potential-consequences-modal.component.scss',
  standalone: false,
})
export class EditPotentialConsequencesModalComponent
  extends EditListModalBase<PotentialConsequence>
  implements OnInit, OnDestroy, OnChanges
{
  @Output() onSubmitForm = new EventEmitter<any>();
  @Output() onCancelForm = new EventEmitter<void>();

  constructor(
    fb: FormBuilder,
    private messageService: MessageService,
    confirmationService: ConfirmationService,
  ) {
    super(
      fb,
      {
        arrayName: 'potentialConsequences',
        confirmDeleteHeader: 'Confirmation de suppression',
        confirmDeleteMessage:
          'Êtes-vous sûr de vouloir supprimer cette consequence ?',
        fields: {},
      },
      confirmationService,
    );
  }

  onSubmit(): void {
    if (!this.isFormValid) {
      this.messageService.add({
        key: this.CONFIRM_DELETE,
        severity: 'error',
        summary: 'Erreur',
        detail: this.validationMessage,
      });
      return;
    }
    this.onSubmitForm.emit(this.buildSubmitResult());
    this.closeModal();
  }

  onCancel(): void {
    this.onCancelForm.emit();
    this.closeModal();
  }
}
